import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import FormFieldColorPicker from '../FormFieldColorPicker';
import FormFieldMediumUploadRow from '../../containers/FormFieldMediumUploadRow';
import styles from './styles.scss';

const propTypes = {
  onImageReset: PropTypes.func.isRequired,
  setActiveSection: PropTypes.func.isRequired,
  setShowMediaGallery: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({
    theme: PropTypes.shape({
      colors: PropTypes.shape({
        primary: PropTypes.string.isRequired,
        secondary: PropTypes.string.isRequired,
        tertiary: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    enabled: PropTypes.bool.isRequired,
    logo: PropTypes.shape({
      alt: PropTypes.string,
      link: PropTypes.shape({
        href: PropTypes.string.isRequired,
        target: PropTypes.string.isRequired,
      }),
      mediumId: PropTypes.string,
      path: PropTypes.string.isRequired,
      title: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

const defaultProps = {};

const FacilityStylingForm = ({
  onImageReset,
  setActiveSection,
  setShowMediaGallery,
  setFieldValue,
  values,
  ...rest
}) => (
  <div data-testid="facility-edit-form-branding" className={styles.customBranding}>
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={4}>
            <FormFieldColorPicker
              label="Primary Color"
              data-testid="facility-edit-form-primary-color"
              description="Headings & prices"
              name="theme.colors.primary"
              required
            />
          </Col>
          <Col xs={4}>
            <FormFieldColorPicker
              data-testid="form-field-color-picker" // Make sure this attribute is applied
              description="Buttons & social media"
              label="Secondary Color"
              name="theme.colors.secondary"
              required
            />
          </Col>
          <Col xs={4}>
            <FormFieldColorPicker
              data-testid="form-field-color-picker" // Make sure this attribute is applied
              description="Footer & hours highlight"
              label="Tertiary Color"
              name="theme.colors.tertiary"
              required
            />
          </Col>
        </Row>
      </Col>
    </Row>
    <Row className={styles.facilityLogoRow}>
      <Col xs={12}>
        <span className={styles.title}>Facility Page Logo</span>
      </Col>
      <Col xs={12}>
        <span>
          This image will display in the header logo widget.
          Horizontal logos that don’t contain extra white space around the edges work best.
        </span>
      </Col>
      <Col xs={12} className={styles.facilityLogoCol}>
        <FormFieldMediumUploadRow
          emptyMessage="Once a facility logo is chosen you will be able to edit its alt and title here."
          mediumId={values.theme.logo.mediumId}
          altField="theme.logo.alt"
          mediumField="theme.logo.mediumId"
          titleField="theme.logo.title"
          handleReset={onImageReset}
          setActiveSection={setActiveSection}
          setShowMediaGallery={setShowMediaGallery}
          setFieldValue={setFieldValue}
          values={values}
          {...rest}
        />
      </Col>
    </Row>
  </div>
);

FacilityStylingForm.propTypes = propTypes;
FacilityStylingForm.defaultProps = defaultProps;

export default FacilityStylingForm;
